import { jsx as _jsx } from "react/jsx-runtime";
export const ProductGalleryThumbnailImage = ({ item, idx = 0 }) => {
    const thumbnailUrl = (item.type === "video" && item.videoContentDto && item.previewPath) || item.path;
    if (!thumbnailUrl) {
        return null;
    }
    return (_jsx("img", { src: thumbnailUrl, alt: item.label ?? "", className: "aem-carousel__thumbnailImg", "data-testid": `aem-carousel__thumbnail-${idx}` }));
};
//# sourceMappingURL=ProductGalleryThumbnailImage.js.map